import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import * as selectors from './selectors'
import { messageErrorHide, messageSuccessHide } from 'Global/Stores/messages'
import { changelogModalHide } from 'Global/Stores/modals'

export default function(WrappedComponent) {
  const Enhancer = props => <WrappedComponent {...props} />

  const mapStateToProps = (state, ownProps) => ({
    modals: selectors.modals(state),
    messages: selectors.messages(state),
  })

  const mapDispatchToProps = (dispatch, ownProps) => ({
    hideChangelogModal: () => dispatch(changelogModalHide()),
    hideErrorMessage: () => dispatch(messageErrorHide()),
    hideSuccessMessage: () => dispatch(messageSuccessHide()),
  })

  Enhancer.displayName = 'GlobalMessageEnhancer'

  Enhancer.propTypes = {
    hideChangelogModal: PropTypes.func.isRequired,
    hideErrorMessage: PropTypes.func.isRequired,
    hideSuccessMessage: PropTypes.func.isRequired,
    modals: PropTypes.shape({
      changelog: PropTypes.shape({
        visible: PropTypes.bool.isRequired,
      }).isRequired,
      confirmation: PropTypes.shape({
        message: PropTypes.string.isRequired,
        onAccept: PropTypes.object.isRequired,
        visible: PropTypes.bool.isRequired,
      }).isRequired,
      feedback: PropTypes.shape({
        visible: PropTypes.bool.isRequired,
      }).isRequired,
      groupCreate: PropTypes.shape({
        visible: PropTypes.bool.isRequired,
      }).isRequired,
      myAccount: PropTypes.shape({
        visible: PropTypes.bool.isRequired,
      }).isRequired,
      reservationCreate: PropTypes.shape({
        visible: PropTypes.bool.isRequired,
      }).isRequired,
      reservationEdit: PropTypes.shape({
        reservation: PropTypes.object.isRequired,
        visible: PropTypes.bool.isRequired,
      }).isRequired,
      settings: PropTypes.shape({
        visible: PropTypes.bool.isRequired,
      }).isRequired,
    }).isRequired,
    messages: PropTypes.shape({
      error: PropTypes.shape({
        message: PropTypes.string.isRequired,
        visible: PropTypes.bool.isRequired,
      }).isRequired,
      success: PropTypes.shape({
        message: PropTypes.string.isRequired,
        visible: PropTypes.bool.isRequired,
      }).isRequired,
    }).isRequired,
  }

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Enhancer)
}
